import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name.' }
      ]
      },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
      },
    CellNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' },
        { type: 'required', message: 'Please fill in required field.' },
      ]
      },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event.' },
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    category: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
      },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
       },
    reference: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    operation: {
      validations: []
    },
    notes: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
       {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Cell Phone Number:*',
            mapping: 'CellNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Proposed Event Date:*',
            mapping: 'eventDate'
           }
        ]
      },
      {
        fields: [
          {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'What type of event are you interested in booking?:*',
          options: [
            { label: 'Anniversary', value: 'Anniversary'},
            { label: 'Baby Shower', value: 'Baby Shower'},
            { label: 'Birthday Party', value: 'Birthday Party'},
            { label: 'Bridal shower', value: 'Bridal shower'},
            { label: 'Ceremony', value: 'Ceremony'},
            { label: 'Community Event', value: 'Community Event'},
            { label: 'Corporate Event', value: 'Corporate Event'},
            { label: 'Engagement Party', value: 'Engagement Party'},
            { label: 'Fundraiser', value: 'Fundraiser'},
            { label: 'Graduation Party', value: 'Graduation Party'},
            { label: 'Holiday Party', value: 'Holiday Party'},
            { label: 'Rehearsal Dinner', value: 'Rehearsal Dinner'},
            { label: 'Retirement Party', value: 'Retirement Party'},
            { label: 'Wedding', value: 'Wedding'},
            { label: 'Other', value: 'Other'},
          ],
          mapping: 'category'
         }
        ]
      },
      {
        fields: [
          {
          type: 'text',
          size: 'Medium',
          label: 'Estimated Guest Count:*',
          mapping: 'plannedguestcount'
           }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us?:*',
            options: [
              { label: 'Website', value: 'Website'},
              { label: 'Google', value: 'Google'},
              { label: 'Facebook', value: 'Facebook'},
              { label: 'Instagram', value: 'Instagram'},
              { label: 'TheKnot', value: 'TheKnot'},
              { label: 'Vendor Referral', value: 'Vendor Referral'},
              { label: 'Client Referral', value: 'Client Referral'},
              { label: 'Other', value: 'Other'},
              { label: 'Unknown', value: 'Unknown'},
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Anything else we should know about your event?:*',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Consult Now - Tannenbaum',
    formId: '2176',
    clientKey: '8B881076-0215-44CD-9AB8-B9F908B4F704',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://tannenbaumevents.com/thank-you/',
    submissionText: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
